import { render, staticRenderFns } from "./EducationDivPopup.vue?vue&type=template&id=dc1e070a&scoped=true&"
import script from "./EducationDivPopup.vue?vue&type=script&lang=js&"
export * from "./EducationDivPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1e070a",
  null
  
)

export default component.exports